export default "__VITE_ASSET__BlwJBZYy__"